// GameState.js — plain data + a tiny emitter. No DOM, no rules.

export const Phase = {
    LOADING: "LOADING",
    READY: "READY",
    PLAYING: "PLAYING",
    LINE_DONE: "LINE_DONE", // all bars on the active line collected
    SONG_END: "SONG_END",
};

export function createInitialState() {
    return {
        phase: Phase.LOADING,
        score: 0,
        combo: 0,
        stepsLeft: 0,
        lineIndex: -1,
        miku: { col: 0, row: 0 },
        // Active line's bars, in reading order, laid along a connected path:
        // { id, char, col, row, order, collected, missed }
        items: [],
        collectedCount: 0,
        pathIndex: 0,
        lineText: "",
        feedbackMessage: "",
        feedbackType: null,

        // --- Music sync (driven by the rAF clock in TextAliveController) ---
        lineChars: [],        // characters of the active line, for per-char coloring
        activeCharIndex: -1,  // index of the char being sung right now (-1 = none yet)

        // Directions to walk the path, one per gap between bars ('up'|'down'|
        // 'left'|'right'). Length = bars - 1. Drives the beat-track arrows.
        moves: [],
    };
}

// Minimal pub/sub so the engine stays DOM-free and views just subscribe.
export class Emitter {
    constructor() {
        this._listeners = new Set();
    }
    subscribe(fn) {
        this._listeners.add(fn);
        return () => this._listeners.delete(fn);
    }
    emit(payload) {
        for (const fn of this._listeners) fn(payload);
    }
}
